var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.mobileStyle)?[(_vm.activeLive)?_c('MLivesLive'):_c('MLivesMain')]:[(_vm.activeLive)?_c('LivesLive'):_c('LivesMain',{attrs:{"windowWidth":_vm.windowWidth}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }